import Vue from "vue"
import App from "./App.vue"
import store from "./store/store"
import "./registerServiceWorker"
import VueShortkey from "vue-shortkey"
import VueSpatialNavigation from "vue-spatialnavigation"
import bootstrap_vue from "bootstrap-vue"

import { library } from "@fortawesome/fontawesome-svg-core"
import {
  faUserSecret, faBolt, faTimesCircle, faMoneyBillAlt, faHashtag, faDollarSign, faClock, faInfinity, faHourglassStart, faCloud, faSmog, faTimes } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"

library.add(faUserSecret, faBolt, faTimesCircle, faMoneyBillAlt, faHashtag, faDollarSign, faClock, faInfinity, faHourglassStart, faCloud, faSmog, faTimes)

Vue.component("font-awesome-icon", FontAwesomeIcon)
Vue.use(VueShortkey)
Vue.use(VueSpatialNavigation)
Vue.use(bootstrap_vue)

Vue.config.productionTip = false

new Vue({
  store,
  render: (h) => h(App),
}).$mount("#app")
